import { createReducer, on } from '@ngrx/store';
import * as RecentPoliciesActions from './recent-policies.actions';

export interface RecentPolicy {
    policyNumber: string;
    lineOfBusiness: string;
}

export interface RecentPoliciesState {
    policies: RecentPolicy[];
}

export const initialState: RecentPoliciesState = {
    policies: [],
};

export const recentPoliciesReducer = createReducer(
    initialState,
    on(RecentPoliciesActions.addRecentPolicy, (state, { policyNumber, lineOfBusiness }) => {
        const exists = state.policies.some((p) => p.policyNumber.toLowerCase() === policyNumber.toLowerCase());
        if (exists) return state;
        const updated = [{ policyNumber: policyNumber.toUpperCase(), lineOfBusiness }, ...state.policies];
        return { policies: updated.length > 5 ? updated.slice(0, 5) : updated };
    }),
    on(RecentPoliciesActions.clearRecentPolicies, () => ({ ...initialState }))
);
